import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useCreditItemsForDrivers from "utils/hooks/useCreditItemsForDrivers";
import {ArboCreditsLogo} from "pages/Front/Booking/Credits/CreditCalculator/components/icons";
import {PackagesCartItem} from "types/entities/PackagesCartItem";

const CreditTicketPackageItem = (props: {personIndex: number}) => {
    const {t} = useTranslation();
    const {getCreditItemForPersonIndex} = useCreditItemsForDrivers();
    const [creditItem, setCreditItem] = useState<PackagesCartItem | null>(null);

    useEffect(() => {
        const creditItemForPersonIndex = getCreditItemForPersonIndex(props.personIndex);
        if (creditItemForPersonIndex) {
            setCreditItem(creditItemForPersonIndex);
        }
    }, []);

    return (
        <div className={"CreditTicketPackageItem flex items-center justify-start gap-2 grow pl-4 border-l border-gray-200"}>
            <ArboCreditsLogo size={40} className={"shrink-0"} />
            {creditItem && creditItem.packageItem?.article.creditPackage && (
                <span>
                    {t("Credits")}: <b>{creditItem.packageItem.article.creditPackage.amount_total}</b>
                </span>
            )}
            {!creditItem && (
                <span>
                    {t("Credits")}: <b>{t("Empty")}</b>
                </span>
            )}
        </div>
    );
};

export default CreditTicketPackageItem;
